module.exports = __webpack_public_path__ + "static/img/live-to-learn__large.aade704.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/aside/live-to-learn__large.jpg
// module id = wFy9
// module chunks = 1